import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRoadtrips } from '../services/api';
import './RoadtripList.css';

const RoadtripList = () => {
    const [roadtrips, setRoadtrips] = useState({ done: [], upcoming: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('done');

    useEffect(() => {
        const fetchRoadtrips = async () => {
            try {
                const response = await getRoadtrips();
                if (response.success) {
                    setRoadtrips({
                        done: response.data.done || [],
                        upcoming: response.data.upcoming || []
                    });
                } else {
                    setError(response.message || 'Erreur lors du chargement des données');
                }
            } catch (err) {
                console.error('Erreur fetchRoadtrips:', err);
                setError('Erreur de connexion au serveur');
            } finally {
                setLoading(false);
            }
        };

        fetchRoadtrips();
    }, []);

    if (loading) return <div className="alert alert-info">Chargement...</div>;
    if (error) return <div className="alert alert-danger">{error}</div>;

    const currentRoadtrips = activeTab === 'done' ? roadtrips.done : roadtrips.upcoming;

    return (
        <div className="roadtrips-container">
            <div className="header">
                <h1>Mes Roadtrips</h1>
                <Link to="/new-roadtrip" className="btn btn-primary">
                    Nouveau Roadtrip
                </Link>
            </div>

            <div className="tabs">
                <button 
                    className={`tab ${activeTab === 'done' ? 'active' : ''}`}
                    onClick={() => setActiveTab('done')}
                >
                    Déjà faits ({roadtrips.done.length})
                </button>
                <button 
                    className={`tab ${activeTab === 'upcoming' ? 'active' : ''}`}
                    onClick={() => setActiveTab('upcoming')}
                >
                    À venir ({roadtrips.upcoming.length})
                </button>
            </div>

            <div className="roadtrips-grid">
                {currentRoadtrips.map(roadtrip => (
                    <div key={roadtrip.roadtrip_id} className={`roadtrip-card ${activeTab === 'upcoming' ? 'upcoming' : ''}`}>
                        <div className="roadtrip-header">
                            <h3>{roadtrip.roadtrip_name}</h3>
                            {roadtrip.date_depart_prevu && roadtrip.date_depart_prevu !== '0000-00-00' && (
                                <span className="dates">
                                    {new Date(roadtrip.date_depart_prevu).toLocaleDateString()} 
                                    - 
                                    {new Date(roadtrip.date_fin_prevu).toLocaleDateString()}
                                </span>
                            )}
                        </div>
                        <div className="roadtrip-body">
                            {roadtrip.description && (
                                <p className="description">{roadtrip.description}</p>
                            )}
                            
                            {activeTab === 'upcoming' && roadtrip.lieux && (
                                <div className="lieux">
                                    <strong>Lieux :</strong>
                                    <p>{roadtrip.lieux}</p>
                                </div>
                            )}
                            
                            {activeTab === 'upcoming' && roadtrip.etapes && (
                                <div className="etapes">
                                    <strong>Étapes :</strong>
                                    <div className="etapes-list">
                                        {roadtrip.etapes.split(',').map((etape, index) => (
                                            <span key={index} className="etape-tag">
                                                {etape.trim()}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {activeTab === 'done' && roadtrip.roadtrip_status === "2" && (
                                <div className="stats">
                                    <span>{roadtrip.total_travels} étapes</span>
                                </div>
                            )}
                        </div>
                        <div className="roadtrip-footer">
                            <Link 
                                to={`/roadtrip/${roadtrip.roadtrip_id}`}
                                className="btn btn-outline-primary"
                            >
                                Voir le détail
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RoadtripList; 